import React, { useState, useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import "../productList/productList.css";
import { getDeliveredOrders } from "../../Data/Orders";
import { getDeliveredErrands } from "../../Data/Errands";

import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import { firebase_Db } from "../../config/firebaseConfig";

function DeliverdItems() {
  const [openOther, setOther] = useState(false);

  const [allDOrders, setallDOrders] = useState([]);
  const [allDErrans, setallDErrans] = useState([]);
  const DBorders = "deliveredOrders";
  const DBerrands = "deliverederrands";

  useEffect(() => {
    const fetchErrans = async () => {
      const erras = await firebase_Db.collection(DBorders).get();

      setallDErrans(
        erras.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );

      return fetchErrans();
    };
  }, [allDErrans]);

  useEffect(() => {
    const fetchOrders = async () => {
      const orders = await firebase_Db.collection(DBerrands).get();
      setallDOrders(
        orders.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );

      return fetchOrders();
    };
  }, [allDOrders]);

  return (
    <div className="content productContent">
      <div className="bar">
        <button className="products-btn" onClick={() => setOther(false)}>
          Delivered Errands
        </button>
        <button className="products-btn" onClick={() => setOther(true)}>
          Delivered Orders
        </button>{" "}
      </div>
      <div className="divider"> </div>{" "}
      {openOther
        ? allDOrders.map((orders, index) => {
            return <DeliveredOrders Ddata={orders} />;
          })
        : allDErrans.map((errands, index) => {
            return <DeliveredErrands Edata={errands} />;
          })}{" "}
    </div>
  );
}

const DeliveredErrands = ({ Edata }) => {
  const { data, id } = Edata;
  return (
    <div>
      <List key={id}>
        <ListItem>
          <ListItemAvatar>
            <Avatar
              alt="Remy Sharp"
              src={`${data.imgUrl}`}
              sx={{ width: 100, height: 100 }}
              className="productlist_avatar"
            />
          </ListItemAvatar>
          <ListItemText
            primary={`${data.name}`}
            secondary={`Ghc20000`}
            className="productlist_ItemText"
          />
          <ListItemText primary={`category: `} secondary={"desc"} />
        </ListItem>
      </List>
    </div>
  );
};
const DeliveredOrders = ({ Ddata }) => {
  const { data, id } = Ddata;
  return (
    <div>
      <List key={id}>
        <ListItem>
          <ListItemAvatar>
            <Avatar
              alt="Remy Sharp"
              src={`${data.product_imgUrl}`}
              sx={{ width: 100, height: 100 }}
              className="productlist_avatar"
            />
          </ListItemAvatar>
          <ListItemText
            primary={`${data.product_name}`}
            secondary={`${data.price}`}
            className="productlist_ItemText"
          />
          <ListItemText
            primary={`User: ${data.user.name}`}
            secondary={"desc"}
          />
        </ListItem>
      </List>
    </div>
  );
};

export default DeliverdItems;
